const apikey = window._gkey; // get google api key from global scope (api keys is in poi_index.html)

export default class PoiMapsLoader {
    static load() {
        return new Promise(function(resolve, reject) {
            const $s = document.createElement('script');

            $s.type = 'text/javascript';
            $s.src = `https://maps.googleapis.com/maps/api/js?key=${apikey}&callback=&libraries=geometry`;
            $s.async = true;
            $s.onerror = function(err) {
                reject(err, $s);
            };
            $s.addEventListener('load', function() {
                resolve(window.google);
            });

            const $t = document.getElementsByTagName('script')[0];
            $t.parentElement.insertBefore($s, $t);
        });
    }
}


// WEBPACK FOOTER //
// ./front/treasurybond/js/components/poi/poi-maps-loader.js